import * as React from 'react';

import { TransactionAmountType } from '../../../__generated__/globalTypes';

import { TransactionFilterDropdown, type IFilterOption } from './TransactionFilterDropdown';

interface IAmountTypeFilterDropdownProps {
  selectedTypes: TransactionAmountType[];
  onSelect: (types: TransactionAmountType[]) => void;
}

export const AmountTypeFilterDropdown = ({ selectedTypes, onSelect }: IAmountTypeFilterDropdownProps) => {
  const transactionAmountTypeOptions = React.useMemo<IFilterOption[]>(
    () => [
      { id: TransactionAmountType.Credit, label: 'Credit' },
      { id: TransactionAmountType.Debit, label: 'Debit' },
    ],
    []
  );

  return (
    <TransactionFilterDropdown
      label="Type"
      options={transactionAmountTypeOptions}
      selectedIds={selectedTypes}
      onSelect={(ids) => onSelect(ids as TransactionAmountType[])}
      hideSearch={true}
      className="h-auto"
      selectionMode="single"
    />
  );
};
